var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.42857,
    y: 5.42857,
    width: 89.1429,
    height: 89.1429,
    rx: 44.5714,
    fill: "#25272C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42857,
    y: 5.42857,
    width: 89.1429,
    height: 89.1429,
    rx: 44.5714,
    stroke: "white",
    strokeWidth: 9.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8605 45.8569V41.2854C40.8605 36.2854 44.9319 32.1426 50.0033 32.1426C55.0033 32.1426 59.1462 36.2854 59.1462 41.2854V45.8569H61.4319C63.9319 45.8569 66.0033 47.9283 66.0033 50.4283V64.1426C66.0033 66.714 63.9319 68.714 61.4319 68.714H38.5748C36.0033 68.714 34.0033 66.714 34.0033 64.1426V50.4283C34.0033 47.9283 36.0033 45.8569 38.5748 45.8569H40.8605ZM44.2891 45.8569H55.7176V41.2854C55.7176 38.1426 53.1462 35.5712 50.0033 35.5712C46.7891 35.5712 44.2891 38.1426 44.2891 41.2854V45.8569ZM37.4319 64.1426C37.4319 64.7854 37.9319 65.2854 38.5748 65.2854H61.4319C62.0033 65.2854 62.5748 64.7854 62.5748 64.1426V50.4283C62.5748 49.8569 62.0033 49.2854 61.4319 49.2854H38.5748C37.9319 49.2854 37.4319 49.8569 37.4319 50.4283V64.1426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTag);
export default __webpack_public_path__ + "static/media/lockTag.123dd602fd594171cb04e21092ef9ffa.svg";
export { ForwardRef as ReactComponent };